<!--
客服工单
-->
<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item
        v-for="(listItem,index) in workOrderTable"
        :key="index"
        :name="listItem.listAll"
      >
        <span
          class="order-title"
          slot="title"
        >
          <span
            class="total-view"
            v-if="(listAllObj[listItem.listAll]||[]).length"
          >{{(listAllObj[listItem.listAll]||[]).length||''}}</span>
          {{$lang(listItem.title)}}
        </span>
        <detail-list-all-table
          :value="(listAllObj[listItem.listAll]||[])"
          :option="listItem.option"
          @getItem="listItem.getItem($event,listItem.listMin)"
        >
          <template
            slot="urlsSlot"
            slot-scope="{item}"
          >
            <span
              v-if="item.problemPieceAttachment && item.problemPieceAttachment.length"
              class="link-color pointer-view"
              @click="showAllDiglog(item.problemPieceAttachment,'path')"
            >{{$lang('查看')}}</span>
          </template>
          <div
            v-if="listItem.optionMin"
            slot="detailView"
            class="table-min"
          >
            <div class="min-label">{{$lang('处理记录')}}</div>
            <div class="min-list">
              <div class="list-head">
                <div
                  v-for="(head,index) in  listItem.optionMin.head"
                  :style="head.style||{width:'120px'}"
                  :key="index"
                >{{$lang(head.label)}}</div>
              </div>
              <div
                v-for="(minData,index) in listMinObj[listItem.listMin]"
                :key="index"
              >
                <div
                  :style="head.style||{width:'120px'}"
                  v-for="(head,index) in  listItem.optionMin.head"
                  :key="index"
                >
                  <span
                    class="see-btn"
                    v-if="head.isPaths&&minData[head.urlProp||'urls']&&minData[head.urlProp||'urls'].length"
                    @click.stop="showAllDiglog(minData[head.urlProp||'urls'],'path')"
                  >{{ $lang('查看') }}</span>
                  <span v-else>{{minData[head.prop]||'--'}}</span>
                </div>
              </div>
            </div>
          </div>
        </detail-list-all-table>
      </el-collapse-item>
    </el-collapse>
    <!-- 附件预览 -->
    <BaseAnnexView
      :visible.sync="annexDialogVisible"
      :fileListResAll="fileListResAll"
    />
  </div>
</template>

<script>
// import { baseInfoTable } from './option'
import { isEmptyObj } from '@/common/utils/tool'
import CustomerServiceMixin from './CustomerServiceMixin'

const baseList = {
  workOrderList: [], // 普通
  claimOrderList: [], // 理赔
  platOrderList: [], // 平台
  postalOrderAllList: [], // 邮政
  arbitrationList: [], // 仲裁
  qualityList: [], // 质量
  monitorAllList: [],
  eventWorkOrderList: [], // 事件工单
  orderTaskList: [] // 催件任务单
}
export default {
  name: 'CustomerServiceOrder',
  mixins: [CustomerServiceMixin],
  props: {
    customerServiceOrder: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      activeNames: [],
      isEmptyObj,
      num: 0,
      listAllObj: this.deepClone(baseList)
    }
  },
  watch: {
    customerServiceOrder: {
      handler(val) {
        this.activeNames = []
        this.listAllObj = this.deepClone(baseList)
        const { workOrderListAll, postalOrderAllList, arbitrationList, qualityList } = val || {}; (workOrderListAll || []).map(o => {
          [1, 4].includes(o.workOrderType) && this.listAllObj.workOrderList.push(o)
          o.workOrderType === 2 && this.listAllObj.claimOrderList.push(o)
          o.workOrderType === 3 && this.listAllObj.platOrderList.push(o)
          o.workOrderType === 6 && this.listAllObj.eventWorkOrderList.push(o)
          o.workOrderType === 7 && this.listAllObj.orderTaskList.push(o)
        })
        this.listAllObj.postalOrderAllList = postalOrderAllList || []
        this.listAllObj.arbitrationList = arbitrationList || []
        this.listAllObj.qualityList = qualityList || [];
        // 默认有数据展开
        ['workOrderList', 'claimOrderList', 'platOrderList', 'postalOrderAllList', 'arbitrationList', 'qualityList', 'eventWorkOrderList', 'orderTaskList'].forEach(o => {
          this.listAllObj[o].length && this.activeNames.push(o)
        })
        console.log(this.activeNames, '88888888888');
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style scoped lang="scss">
.detail-list-table {
  width: 100%;
  overflow-x: auto;
}
::v-deep .el-collapse {
  .is-active {
    > :nth-child(1) {
      margin-bottom: 10px;
    }
  }
}
.switch-icon {
  display: inline-block;
  position: relative;
  margin-top: 7px;
  .my-icon {
    position: absolute;
    left: 0;
    color: #a1a3a6;
  }
  .my-icon-1 {
    bottom: 0px;
  }
  .my-icon-2 {
    top: -8px;
  }
  .active {
    color: #fb0000;
  }
}

::v-deep .el-collapse-item__header {
  height: 35px;
  margin-bottom: 10px;
}
::v-deep .el-collapse-item__wrap {
  padding: 5px !important;
  overflow-x: auto !important;
}
.total-view {
  display: inline-block;
  background-color: #e60012;
  min-width: 16px;
  padding: 0 4px;
  height: 16px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #fff;
  margin-right: 5px;
}
.order-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin-bottom: 0 !important;
}
::v-deep .el-collapse-item__header::before {
  display: none;
}
::v-deep .detial-view {
  padding: 0 !important;
}
::v-deep .detial-list {
  display: none;
}
.table-min {
  display: flex;
  background-color: #f2f2f2;
  justify-content: flex-start;
  .min-label {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 76px;
    border-right: 1px solid #dcdee1;
  }
  .min-list {
    width: 96%;
    // text-indent: 1rem;
    & > div {
      justify-content: space-between;
      display: flex;
      border-bottom: 1px solid #dcdee1;
      padding: 15px 0;
      padding-left: 5px;
    }
    & > div:last-child {
      border-bottom: none;
    }
    .list-head {
    }
  }
}
.see-btn {
  cursor: pointer;
  color: #e60012;
}
</style>
